import React from 'react';

export type DateRange = { startDate: string; endDate: string };
export type RangePreset = '7d' | '30d' | '90d';

const PRESETS: { key: RangePreset; label: string; days: number }[] = [
  { key: '7d', label: '7d', days: 7 },
  { key: '30d', label: '30d', days: 30 },
  { key: '90d', label: '90d', days: 90 },
];

export const computeRange = (preset: RangePreset): DateRange => {
  const days = PRESETS.find(p => p.key === preset)?.days ?? 7;
  const today = new Date();
  const end = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));
  const start = new Date(end);
  start.setUTCDate(start.getUTCDate() - (days - 1));

  return {
    startDate: start.toISOString().split('T')[0],
    endDate: end.toISOString().split('T')[0],
  };
};

type Props = {
  active: RangePreset;
  onChange: (next: RangePreset) => void;
};

const DateRangePicker: React.FC<Props> = ({ active, onChange }) => {
  return (
    <div className="inline-flex rounded-lg border border-gray-300 bg-white p-0.5 shadow-sm">
      {PRESETS.map(p => (
        <button
          key={p.key}
          type="button"
          onClick={() => onChange(p.key)}
          className={`px-3 py-1 text-xs font-medium rounded-md transition ${
            active === p.key ? 'bg-primary-500 text-white' : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
};

export default DateRangePicker;
